
import { ChargeWaiverRegistrationEntity, EMPTY_CHARGE_WAIVER_REGISTRATION_ENTITY } from "domain/entity/ChargeWaiverRegistration/ChargeWaiverRegistrationEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface ChargeWaiverRegistrationDropdownOptions {
    chargeTypeDropdownOptions: DropdownProps[],
    waiverReasonCodeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
}

export interface ChargeWaiverRegistrationModel {
    isLoading: boolean,
    dynamicOptions: ChargeWaiverRegistrationDropdownOptions,
    chargeWaiverRegistrationList: ChargeWaiverRegistrationEntity[],
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: ChargeWaiverRegistrationEntity[],
    currentRow: ChargeWaiverRegistrationEntity,
    currentEditRow: ChargeWaiverRegistrationEntity,
    chargeDescMap: { [key: string]: string },
    masterState: ChargeWaiverRegistrationViewChangeState,

}
export interface ChargeWaiverRegistrationViewChangeState extends BaseViewChangeSate {
}

export const EMPTY_CHARGE_WAIVER_REGISTRATION_MODEL: ChargeWaiverRegistrationModel = {
    isLoading: false,
    chargeWaiverRegistrationList: [],
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_CHARGE_WAIVER_REGISTRATION_ENTITY },
    currentEditRow: { ...EMPTY_CHARGE_WAIVER_REGISTRATION_ENTITY },
    dynamicOptions: {
        waiverReasonCodeDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {}
    },
    chargeDescMap: {},
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}